import script from "./transaction.vue?vue&type=script&setup=true&lang=js"
export * from "./transaction.vue?vue&type=script&setup=true&lang=js"

import "./transaction.vue?vue&type=style&index=0&id=8afaf4b0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8afaf4b0"]])

export default __exports__